export const ANALYTICS_EVENTS = {
  EVENT_TYPES: {
    PAGE_VIEW: 'page_view',
    NAVIGATION: 'navigation',
    FORM_SUBMIT: 'form_submit',
    LOG_IN: 'log_in',
    SIGN_UP: 'sign_up',
    ADD_TO_CART: 'add_to_cart',
    REMOVE_FROM_CART: 'remove_from_cart',
    VIEW_ITEM_LIST: 'view_item_list',
    SELECT_ITEM: 'select_item',
    SUBSCRIBER_FORM_SUBMIT: 'subscriber_form_submit',
    BEGIN_CHECKOUT: 'begin_checkout',
    EXPERIMENT_VIEWED: 'experiment_viewed',
    IMPRESSION_VIEW: 'eec.impressionView',
    ADD_PAYMENT_INFO: 'add_payment_info',
    ORDER_PURCHASE: 'purchase',
    REACHED_REVIEW: 'reached_review',
    REACHED_EMAIL_CHECKOUT: 'reached_email_checkout',
    CONTACT_INFO_SUBMIT: 'contact_info_submit',
  },
  NAVIGATION_LOCATION: {
    HEADER: 'header',
    FOOTER: 'footer',
    LEAGUE: 'League',
    TRAVEL_PACKAGE: 'Popular Travel Package',
  },
  FORM_SUBMIT: {
    CONTACT_US: {
      formId: 'con_form',
      formName: 'Contact US',
    },
    GROUP_7: {
      formId: 'grp_form',
      formName: 'Group (7+)',
    },
    GOOGLE_LOGIN: {
      formId: 'googleButton',
      formName: 'Google Login',
    },
    FACEBOOK_LOGIN: {
      formId: 'facebookButton',
      formName: 'Facebook Login',
    },
    APPLE_LOGIN: {
      formId: 'appleButton',
      formName: 'Apple Login',
    },
    LOG_IN: {
      formId: 'login-form',
      formName: 'Login',
    },
    SIGN_UP: {
      formId: 'signup-form',
      formName: 'Sign Up',
    },
    SUBSCRIBER_FORM_SUBMIT: {
      formId: 'Subscribe to Our Newsletter',
      formName: 'newsLetterForm',
    },
  },
  SELECT_ITEM: {
    CATEGORY: {
      TICKETS: 'Tickets',
    },
  },
  CATEGORY: {
    TICKETS: 'Tickets',
    HOTELS: 'Hotels',
    FLIGHTS: 'Flights',
    ADDONS: 'Addons',
  },
  PROVIDERS: {
    TICKETS: 'BS-EP-T',
    FLIGHTS: 'BS-ZP-T',
    ADDONS: 'Miscellaneous',
  },
  IMPRESSION_VIEW: {
    RELATED_PRODUCTS: 'Related products',
    TRAVEL_PACKAGES: 'travel packages',
  },
}

export const EVENT_VARIANTS = {
  ARTIST: 'artists',
  SPORTS: 'sports',
} as const

export type EventVariant = (typeof EVENT_VARIANTS)[keyof typeof EVENT_VARIANTS]
export type EventVariantKeys = keyof typeof EVENT_VARIANTS

export const CART_TYPE = {
  TICKET: 'TICKET',
  HOTEL: 'HOTEL',
  FLIGHT: 'FLIGHT',
  ADDONS: 'ADDONS',
} as const

export type CartType = (typeof CART_TYPE)[keyof typeof CART_TYPE]
